import type { Dayjs } from "dayjs";

import { customRangeWithDayFormat } from "@similarweb/pro-logic-components";

interface IFormatDurationParams {
    from: Dayjs;
    to: Dayjs;
}

export const formatDuration = ({ from, to }: IFormatDurationParams) =>
    `${from.format(customRangeWithDayFormat)}-${to.format(customRangeWithDayFormat)}`;
